import { Avatar, Button, IconButton, Tooltip } from '@dixa/lib-shared-habla';
import { MetaConversation } from 'lib-shared-legacy-types';

import { AppLink } from 'components/appLink';
import { CommandKeybindingsTooltipContent } from 'components/commandKeybindingsTooltipContent';
import { useCommandHandler } from 'utils/commands';
import { useAppSelector } from 'utils/redux/useAppSelector';
import { useAppNavigate } from 'utils/url/useAppNavigate';

import styles from './conversationPreviewActions.module.scss';

type ConversationPreviewActionsProps = {
  onGoToConversation: () => void;
  onClose: () => void;
  metaConversation: MetaConversation;
  csid: number;
};

export const ConversationPreviewActions = ({
  onGoToConversation,
  onClose,
  metaConversation,
  csid,
}: ConversationPreviewActionsProps): JSX.Element => {
  const navigate = useAppNavigate();

  const latestMessageSentNotifications = useAppSelector((state) =>
    state.notifications.currentNotifications.filter(
      ({ type }) => type === 'messageSent',
    ),
  );

  useCommandHandler({
    name: 'conversation:goToConversation',
    actionFn: () => {
      if (latestMessageSentNotifications.length) {
        return;
      }

      navigate({
        path: '/conversation/:csid',
        params: {
          path: {
            csid: `${csid}`,
          },
        },
      });

      onGoToConversation();
    },
  });

  return (
    <div className={styles.root}>
      <div className={styles.avatar}>
        <Avatar
          user={metaConversation.conversation.assignment?.agent ?? null}
        />
      </div>

      <Tooltip
        content={
          <CommandKeybindingsTooltipContent commandName="conversation:goToConversation">
            View conversation
          </CommandKeybindingsTooltipContent>
        }
      >
        <AppLink
          path="/conversation/:csid"
          params={{
            path: {
              csid: `${csid}`,
            },
          }}
          onClick={onGoToConversation}
        >
          <Button variant="secondary">Go to conversation</Button>
        </AppLink>
      </Tooltip>

      <IconButton onClick={onClose} icon="close" variant="secondary" />
    </div>
  );
};
